import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, API } from '../App';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // If coming from AuthCallback with user data, render immediately
  if (location.state?.user) {
    return children;
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }

  // Not logged in - show login page
  if (!user) {
    const handleGoogleLogin = () => {
      // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
      const redirectUrl = window.location.origin + '/admin';
      window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
        <div className="text-center max-w-md">
          {/* Logo */}
          <h1 className="font-display text-4xl text-white mb-2">STUDIOBAR</h1>
          <p className="text-stone-500 text-sm mb-12">Administration</p>
          
          {/* Login Card */}
          <div className="bg-[#0A0A0A] border border-white/10 rounded-lg p-8">
            <h2 className="font-display text-2xl text-white mb-4">
              Connexion Admin
            </h2>
            <p className="text-stone-400 text-sm mb-8">
              Connectez-vous avec votre compte Google pour accéder à l'espace d'administration.
            </p>
            
            <button
              onClick={handleGoogleLogin}
              className="w-full flex items-center justify-center gap-3 bg-white text-black font-medium py-3 px-6 rounded hover:bg-gray-100 transition-colors"
            >
              <svg width="20" height="20" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Se connecter avec Google
            </button>
          </div>

          {/* Back link */}
          <a 
            href="/" 
            className="inline-block mt-8 text-stone-500 hover:text-white text-sm transition-colors"
          >
            ← Retour au site
          </a>
        </div>
      </div>
    );
  }

  // Logged in but not admin
  if (!user.is_admin) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
        <div className="text-center max-w-md">
          <div className="bg-[#0A0A0A] border border-white/10 rounded-lg p-8">
            <h1 className="font-display text-2xl text-white mb-4">Accès Refusé</h1>
            <p className="text-stone-400 mb-6">
              Vous êtes connecté en tant que <span className="text-white">{user.email}</span>, mais vous n'avez pas les droits d'administration.
            </p>
            <p className="text-stone-500 text-sm mb-8">
              Contactez l'administrateur pour obtenir l'accès.
            </p>
            <a href="/" className="btn-primary">
              Retour à l'accueil
            </a>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
